<template>
    <div>
        <div class="zt_bg">
            <div class="wp">
                <img src="../../assets/picture/nxzw/12345.jpg" width="960" height="383">
                <img src="../../assets/picture/nxzw/0507ny_top2.jpg" width="960" height="366">
            </div>
        </div>
        <!-- 限时秒杀 -->
        <div class="bg1 yahei" id="linq">
            <div class="wp" id="z1">
                <img class="zt_tit" src="../../assets/picture/nxzw/1234.png" width="960" height="136">
                <div class="clear"></div>
                <div class="zt_g ov mt15 mt0 z_box1">
                    <div v-for="(xm,index) in product" :key="index">  
                        <router-link :to="{path:'/detail', query:{id:xm.id}}" target="_blank">
                            <img :src="xm.piclink" width="220" height="220">
                            <h3>{{xm.title}}</h3>
                            <div class="money">
                                <b class="xjj">{{xm.price}}<b class="rt_1">{{xm.market_price}}</b></b>
                                <span class="zee"></span>
                            </div>
                            <div class="jian">
                                <span class="txt2">{{xm.sale}}人已经购买</span>
                            </div>
                        </router-link>
                    </div>
                </div>
                <p class="lh20">&nbsp;</p>
            </div>
        </div>
        <!-- 逼真男根 -->
        <div class="bg1 yahei" id="linq2">
            <div class="wp" id="z2">
                <!-- <a href="javascript:;" > -->
                <router-link :to="{path:'/shop/shopsearch?cate_id=13&showVideo=1&title=仿真阳具'}" target="_blank">
                    <img class="zt_tit" src="../../assets/picture/nxzw/0507ny_tit02.jpg" width="960" height="91">
                </router-link>
                <!-- </a> -->
                <div class="clear"></div>
                <div class="zt_g ov mt15 mt0 z_box1">
                    <div v-for="(bzzn,index) in bzzn" :key="index">  
                        <router-link :to="{path:'/detail', query:{id:bzzn.id}}" target="_blank">
                            <img :src="bzzn.piclink" width="220" height="220">
                            <h3>{{bzzn.title}}</h3>
                            <div class="money">
                                <b class="xjj">{{bzzn.price}}<b class="rt_1">{{bzzn.market_price}}</b></b>
                                <span class="zee"></span>
                            </div>
                            <div class="jian">
                                <span class="txt2">{{bzzn.sale}}人已经购买</span>
                            </div>
                        </router-link>
                    </div>
                </div>
                <p class="lh20">&nbsp;</p>
            </div>
        </div>
        <!-- 爆吹神器 -->
        <div class="bg1 yahei" id="linq3">
            <div class="wp" id="z3">
                <router-link :to="{path:'/shop/shopsearch?cate_id=14&showVideo=1&title=震动棒'}" target="_blank">
                    <img class="zt_tit" src="../../assets/picture/nxzw/0507ny_tit3.png" width="960" height="91">
                </router-link>
                <div class="clear"></div>
                <div class="zt_g ov mt15 mt0 z_box1">
                    <div v-for="(bcsq,index) in bcsq" :key="index">  
                        <router-link :to="{path:'/detail', query:{id:bcsq.id}}" target="_blank">
                            <img :src="bcsq.piclink" width="220" height="220">
                            <h3>{{bcsq.title}}</h3>
                            <div class="money">
                                <b class="xjj">{{bcsq.price}}<b class="rt_1">{{bcsq.market_price}}</b></b>
                                <span class="zee"></span>
                            </div>
                            <div class="jian">
                                <span class="txt2">{{bcsq.sale}}人已经购买</span>
                            </div>
                        </router-link>
                    </div>       
                </div>
                <p class="lh20">&nbsp;</p>
            </div>
        </div>
        <!-- G点刺激 -->
        <div class="bg1 yahei" id="linq4">
            <div class="wp" id="z4">
                <router-link :to="{path:'/shop/shopsearch?cate_id=33&showVideo=1&title=阴蒂刺激'}" target="_blank">
                    <img class="zt_tit" src="../../assets/picture/nxzw/0507ny_tit4.png" width="960" height="91">
                </router-link>
                <div class="clear"></div>
                <div class="zt_g ov mt15 mt0 z_box1">
                    <div v-for="(gdcj,index) in gdcj" :key="index">  
                        <router-link :to="{path:'/detail', query:{id:gdcj.id}}" target="_blank">
                            <img :src="gdcj.piclink" width="220" height="220">
                            <h3>{{gdcj.title}}</h3>
                            <div class="money">
                                <b class="xjj">{{gdcj.price}}<b class="rt_1">{{gdcj.market_price}}</b></b>
                                <span class="zee"></span>
                            </div>
                            <div class="jian">
                                <span class="txt2">{{gdcj.sale}}人已经购买</span>
                            </div>
                        </router-link>
                    </div>
                </div>
                <p class="lh20">&nbsp;</p>
            </div>
        </div>
        <!--  -->
        <div class="bg1 yahei" id="linq5">
            <div class="wp" id="z5">\
                <router-link :to="{path:'/shop/shopsearch?cate_id=5&showVideo=1&title=情趣跳蛋'}" target="_blank">
                    <img class="zt_tit" src="../../assets/picture/nxzw/0507ny_tit5.png" width="960" height="91">
                </router-link>
                <div class="clear"></div>
                <div class="zt_g ov mt15 mt0 z_box1">
                    <div v-for="(jqtd,index) in jqtd" :key="index">  
                        <router-link :to="{path:'/detail', query:{id:jqtd.id}}" target="_blank">
                            <img :src="jqtd.piclink" width="220" height="220">
                            <h3>{{jqtd.title}}</h3>
                            <div class="money">
                                <b class="xjj">{{jqtd.price}}<b class="rt_1">{{jqtd.market_price}}</b></b>
                                <span class="zee"></span>
                            </div>
                            <div class="jian">
                                <span class="txt2">{{jqtd.sale}}人已经购买</span>
                            </div>
                        </router-link>
                    </div>
                </div>
                <p class="lh20">&nbsp;</p>
            </div>
        </div>
        <!-- 右侧导航 -->
        <div class="yahei zt_fix" id="zt_fix" v-show="goTopShow">
            <img src="../../assets/picture/nxzw/superman2.png" width="134" height="99">
            <a href="#z1">情趣爆款</a>
            <a href="#z2">逼真男根</a>
            <a href="#z3">潮吹神器</a>
            <a href="#z4">G点刺激</a>
            <a href="#z5">激情跳蛋</a>
            <a href="javascript:;" @click="goTop">返回顶部</a>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
export default {
    data() {
      return {
        scrollTop: '',
        goTopShow: false,
        product:[],
        bzzn:[],
        bcsq:[],
        gdcj:[],
        jqtd:[],
      }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
        this.getXianshiMiaoshaHot()
        this.getBzzn()
        this.getBcsq()
        this.getGdcj()
        this.getJqtd()
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
	    //加计时器，使得返回顶部时有fade 的效果
        handleScroll($event) {
            this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            if (this.scrollTop > 50) {//设置页面滑动多少显示按钮
                $('#zt_fix').addClass('gfix');
                this.goTopShow = true;
            } else {
                $('#zt_fix').removeClass('gfix');
                this.goTopShow = false;
            }
        },
        goTop() {
            let timer = null,
            _that = this;
            cancelAnimationFrame(timer)
            timer = requestAnimationFrame(function fn() {
                if (_that.scrollTop > 0) {
                    _that.scrollTop -= 50;//回到顶部的速度
                    document.body.scrollTop = document.documentElement.scrollTop = _that.scrollTop;
                    timer = requestAnimationFrame(fn)
                } else {
                    cancelAnimationFrame(timer);
                    _that.goTopShow = false;
                }
            })
        },
        //获取限时秒杀产品
        getXianshiMiaoshaHot() {
            this.$api.getShop.getXianshiMiaoshaHot({}).then(res => {
                if (res.code == 200) {
                    this.product = [];
                    var arr = res.result.product;
                    arr.forEach(item => {
                        this.product.push(item);
                    });
                    this.type = res.result.types;
                }
            });
        },
        //获取逼真直男
        getBzzn() {
            this.$api.getShop.getBzzn({}).then(res => {
                if (res.code == 200) {
                    this.bzzn = [];
                    var arr = res.result.bzzn;
                    arr.forEach(item => {
                        this.bzzn.push(item);
                    });
                    this.type = res.result.types;
                }
            });
        },
        //获取爆吹神器
        getBcsq() {
            this.$api.getShop.getBcsq({}).then(res => {
                if (res.code == 200) {
                    this.bcsq = [];
                    var arr = res.result.bcsq;
                    arr.forEach(item => {
                        this.bcsq.push(item);
                    });
                    this.type = res.result.types;
                }
            });
        },
        //获取G点刺激
        getGdcj() {
            this.$api.getShop.getGdcj({}).then(res => {
                if (res.code == 200) {
                    this.gdcj = [];
                    var arr = res.result.gdcj;
                    arr.forEach(item => {
                        this.gdcj.push(item);
                    });
                    this.type = res.result.types;
                }
            });
        },
        //获取激情跳蛋
        getJqtd() {
            this.$api.getShop.getJqtd({}).then(res => {
                if (res.code == 200) {
                    this.jqtd = [];
                    var arr = res.result.jqtd;
                    arr.forEach(item => {
                        this.jqtd.push(item);
                    });
                    this.type = res.result.types;
                }
            });
        },
    }
}
</script>

<style scoped>
.zt_bg{margin:0 auto; height:749px; background:#ec2333 url(../../assets/picture/nxzw/0507nybg.jpg) center 50% no-repeat;}
.tg_box{ width:100%;background:url(http://s.dddua.com/themes/v4/zt/zt_valentine/q_bg.jpg) repeat-x; padding-bottom:30px;}
.zt_bg img{vertical-align:top;}
.t_lh {width:100%; margin:0 auto; height:64px;background:#e34e67;}
.lh80 {height:100px;}
.t_image {padding-bottom:20px;}
.t_list {float:left;padding-left:29px;_padding-left:15px;}
/* .t1{background:url(../../assets/picture/nxzw/t2.png) no-repeat;}
.t2{background:url(../../assets/picture/nxzw/cj_t02.png) no-repeat;}
.t3{background:url(../../assets/picture/nxzw/cj_t03.png) no-repeat;}
.t4{background:url(../../assets/picture/nxzw/cj_t04.png) no-repeat;}
.t5{background:url(../../assets/picture/nxzw/cj_t05.png) no-repeat;} */
.cj_pt{padding-top:25px;}
.cj_pb{padding-bottom:20px}
.menu_bg{width:960px;height:277px;}
.menu_bg .tab{ width:210px;height:53px;line-height:53px;color:#bdbdbd;font-size:14px;margin-top:80px;}
.menu1 { text-align:left;}
.menu1 a{padding:2px 6px 2px 6px;text-decoration:none;border:1px solid #ff8448;color:#fff;}
.menu1 a:hover{padding:2px 6px 2px 6px;background-color:#ff8448; color:#fff;}

.money{height:22px;line-height:24px;width:201px;margin:5px 0 10px 10px;color:#555; position: relative;}
.money b.xjj{float:left;width:82px;color:#3f3d40;font-weight:bold; color: #fb4f89; position: relative;}
.xjj{font-size:16px;}
.zee{float:right;width:38px;height:20px;line-height:20px;padding:0 0 0 5px;font-size:12px;color:#fff;background:url(../../assets/picture/nxzw/icon07.png) no-repeat;_background:none;_filter:progid:DXImageTransform.Microsoft.AlphaImageLoader(enabled='true', sizingMethod='corp', src='static/image/icon07.png');}
.jian{height:13px;line-height:13px;width:196px;/*margin:10px 0 8px 12px;*/margin:0 0 0 12px;color:#aeaeae;}
.jian b{float:left;width:82px; font-weight:normal; color:#aeaeae;}
.jian span{width:100px;text-align:right;font-weight:normal;color:#aeaeae;}
.rt_1{font-weight:normal;color:#aeaeae; text-decoration:line-through; position: absolute; top: -2px; font-size: 11px; margin-left: 5px;}
/* .zt_hot{position:absolute;width:50px;height:50px;margin:5px 0 0 5px; display:block;background:url(../../assets/picture/nxzw/qg.png) 50% 50% no-repeat;} */
.menu_bg h2{float:left; height:53px; line-height:53px; font-weight:normal; font-size:25px; color:#fff;}
.zt_q a{float:left;display:block;}

.bg1{background-color:#fedbec;}
.bg2{background-color:#5335af;}

.zt_t,.zt_ft{height:53px; line-height:53px; float:right; color:#fff;}
.zt_ft{color:#fff;font-size:14px; margin-right:10px;}
.link_list{ width:790px;height:409px; margin:0 auto;}
.link_list a{color:#fff;}
.link_list a:hover{color:#fff;text-decoration:underline;}

.zt_g{padding:12px 10px 4px 4px;width:946px; margin-bottom:0px; background:#ff4526;}
.zt_g a {background-color:#fff;height:323px;padding:4px;width:221px;display:inline; float:left;overflow:hidden;margin:0 0 10px 7px;}
.photo{background-color:#fff;height:379px;width:229px;display:inline; float:left;overflow:hidden;margin:0 0 10px 7px;}
.zt_g a h3{height:36px;line-height:20px;width:193px;overflow:hidden;font-weight:normal;margin:4px auto 10px; color:#555;}
.zt_g p{background-color:#3f3d40; height:36px; line-height:36px;width:210px;overflow:hidden;font-size:16px;margin:0 auto;color:#fff; text-align:center;}
.zt_g a:hover{text-decoration:none;}
.zt_g a:hover p{background-color:#e34e67;}

.zt_fix{width:90px;position:fixed;display:none;left:50%;margin-left:500px;top:150px;z-index:10;}
.zt_fix a{background-color:#e8bc52;line-height:35px;height:35px;width:100%;display:block;margin-top:1px;font-size:14px;color:#fff;text-align:center;border:1px solid #f7f7f7;}
.zt_fix a:hover{background-color:#e8bc52;color:#ff617c;text-decoration:none;}
.mt0{margin-top: 0;}
.hotpd{background-color: #6432ce;}
.hotpd a{display:inline-block; margin-left: 10px;}
.z_box1{background-color: #fedbec;}
.z_box3,.hotpd2{background-color: #b232ce;}
.z_box4,.hotpd3{background-color: #ce3295;}
.z_box2{background-color: #430062;}
.z_box5{background-color: #f3164b;}
.z_box6{background-color: #963f4e;}
.zt_tit{display: block; margin: 0; padding: 0;}
.zee{background:url(../../assets/picture/nxzw/zs_shoping.gif) left top no-repeat; width: 41px; height:40px; padding:0; display: block; position: absolute; right: 0; top: 4px;}
.gfix{-webkit-animation:scaleDown 0.5s ease both;-moz-animation:scaleDown 0.5s ease both;animation:scaleDown 0.5s ease both;display:block;_display:none;}
@-webkit-keyframes scaleDown {0%{opacity:0;-webkit-transform:scale(1.5);}100%{opacity:1;-webkit-transform:scale(1);}}
@-moz-keyframes scaleDown {0%{opacity:0;-moz-transform:scale(1.5);}100%{opacity:1;-moz-transform:scale(1);}}
@keyframes scaleDown {0%{opacity:0;transform: scale(1.5);}100%{opacity:1;transform: scale(1);}}
.wp{width: 960px;margin: 0 auto;}
</style>


// WEBPACK FOOTER //
// src/components/nxzw/Index.vue